<template>
  <!-- 消息通知  -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems"
          @click="readThem()"
          >标记为已读
        </el-button>
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems"
          @click="readAll()"
          >全部已读
        </el-button>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <mytable
      :tableHeigth="tableHeigth"
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="true"
      :isselection="true"
      :isShowMoreOperate="false"
      :btnsList="btnsList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      :showFilter="false"
    >
    </mytable>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
    </paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    >
    </sorttable>

    <!-- 弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
    >
      <div>
        <h2>{{ detailsData.subTitle }}</h2>
        <div class="diaTimes">{{ detailsData.createTime }}</div>
        <div>{{ detailsData.content }}</div>
      </div>
      <!-- <div class="glo_dialogForm">
        <el-form
          v-if="isShowDialog"
          class="diaForm"
          ref="dialogFormRef"
          :model="dialogForm"
          label-width="100px"
          :rules="rulesForm"
        >
          <el-form-item class="dialogFormItems" label="退单编号:">
            <el-input
              placeholder=""
              clearable
              disabled
              v-model="dialogForm.number"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="chargebackStatus"
            label="审核状态:"
          >
            <el-select
              v-model="dialogForm.chargebackStatus"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in chargeback_StatusList"
                :key="index"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="3"
              v-model="dialogForm.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div> -->
    </myDialog>
  </div>
</template>
<script>
import tableListNew from "@/pages/tableListNew.js";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import multitime from "@/components/multiTime.vue";
import myDialog from "@/components/Dialog.vue";
import queryCondition from "@/components/queryCondition.vue";
import queryBtns from "@/components/queryBtns.vue";
import mytable from "@/components/table/table.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
export default {
   mixins: [tableListNew],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    multitime,
    myDialog,
    uploadimgs,
    queryBtns,
    queryCondition,
    mytable
  },
  data() {
    return {
      detailsData: {
        content: "",
        createTime: "",
        isRead: "",
        noticeCategory: "",
        noticeMemberId: "",
        subTitle: "",
      },
      isShowOperate: true, //是否显示右边操作
      isShowMoreOperate: true, //是否显示右边更多操作
      pageGroupName: "my_notice_list", //  页面标识
      reportFiledsNumber: "my_notice_list", // 动态 条件、表头
      btnsList:[],
      btnsMoreList:[],
      Operatewidth: "220px", //操作列的列宽
      immediate:true,
      fileNameLists: [], //上传组件的
      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "消息详情",
      diaWidth: "40%",
      dialogForm: {
        // 弹窗表单数据
        chargebackId: "",
        chargebackStatus: "",
        remarks: "",
        number: "",
      },
      rulesForm: {
        chargebackStatus: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },
    };
  },
  updated() {
  },
  created() {
  },
  activated() {
  },
  mounted() {},
  watch: {},
  methods: {
    // 全部已读
    readAll(row) {
      this.$confirm("是否把当前消息 全部标记为已读?", "提示:")
        .then(() => {
          this.$API.readAll().then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          });
        })
        .catch(() => {});
    },
    readThem(){
      if (this.selectTableData.length < 1) {
        this.$message.error("请选择需要操作的数据");
        return false;
      }
      this.biaoJi()
    },
    // 标记已读
    biaoJi(row) {
      this.$confirm("是否把当前消息 标记为已读?", "提示:")
        .then(() => {
          let noticeIds = []
          if(row){
            noticeIds = [row.noticeId]
          }else{
            noticeIds = this.selectTableData.map(item=>item.noticeId)
          }
          this.$API
            .readNotice({
              noticeIds
            })
            .then((res) => {
              this.$message.success(res.data.message || "操作成功");
              this.getData();
            });
        })
        .catch(() => {});
    },
    getDetails(row) {
      this.$API
        .noticeDetail({
          noticeId: row.noticeId,
        })
        .then((res) => {
          console.log(res, "详情");
          let datas = res.data.result || {};
          this.isShowDialog = true;
          if (datas) {
            this.detailsData = datas;
            this.dialogTitle = res.data.result.title || "消息详情";
          }
        });
    },

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            chargebackId: this.dialogForm.chargebackId || "",
            chargebackStatus: this.dialogForm.chargebackStatus || "",
            remarks: this.dialogForm.remarks || "",
          };
          this.$API.wtl_examineChargeback(param).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.isShowDialog = false;
            this.getData();
          });
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },
  },
};
</script>
<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}

.diaTimes {
  border-bottom: 1px solid #d7d7d7;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
</style>
